import { Component, Input } from '@angular/core';
import { APP_MODE, CalendarAdditionalConfig } from '../../../models';
import { CalendarStorageService } from '../services/calendar-storage.service';
import { BaseComponent } from '../../../core';

@Component({ template: '' })
export abstract class CoreCalendarEntryComponent extends BaseComponent {
  private _mode: APP_MODE;
  @Input() set mode(value: APP_MODE) {
    this._mode = value;
    this.calendarStorageService.setCalendarMode(value);
  }
  get mode(): APP_MODE {
    return this._mode;
  }

  private _calendarAdditionalConfig: CalendarAdditionalConfig;
  @Input() set calendarAdditionalConfig(value: CalendarAdditionalConfig) {
    this._calendarAdditionalConfig = value;
    this.calendarStorageService.setCalendarAdditionalConfig(value);
  }
  get calendarAdditionalConfig(): CalendarAdditionalConfig {
    return this._calendarAdditionalConfig;
  }

  protected constructor(
    protected calendarStorageService: CalendarStorageService
  ) {
    super();
  }
}
